import { CheckCircleOutlined } from "@mui/icons-material";
import { Stack } from "@mui/material";
import type { FormSubmissionDetailDto } from "src/http";
import { ItemProperty } from "../itemProperties";
import { TaskItemLabel } from "../taskItems";

interface Props {
  formSubmission: FormSubmissionDetailDto;
}

const FormSubmissionReferencedTasksProperty = (props: Props) => {
  return (
    <ItemProperty labelIcon={<CheckCircleOutlined />} label="Referenced Tasks">
      <Stack spacing={0.5}>
        {props.formSubmission.referencedTaskItems.map((taskItem) => (
          <TaskItemLabel
            key={taskItem.taskItemGuid}
            taskItemGuid={taskItem.taskItemGuid}
            taskItemDescription={taskItem.description}
            taskItemStatus={taskItem.status}
            taskItemTeam={taskItem.team}
          />
        ))}
      </Stack>
    </ItemProperty>
  );
};

export { FormSubmissionReferencedTasksProperty };
